import React from "react";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.js";

import modalStyle from "assets/jss/material-kit-react/modalStyle";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Check, Clear } from "@material-ui/icons";
import { Col, Row } from "antd";
import SignaturePad from "react-signature-canvas";
import "./style.css";
import { baseUrl } from "../../../config/urls";
import sadEmoji from "../../../assets/img/sad.png";
const useStyles = makeStyles(modalStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

var sigPad = {};

const clearPad = () => {
  sigPad.clear();
};

const trimSign = () => {
  return sigPad.getTrimmedCanvas().toDataURL("image/png");
};

export default function UploadModal({
  toggle,
  open,
  onChangeFile,
  upload,
  data,
  onSave,
  onFillSurvey,
}) {
  const classes = useStyles();

  return (
    <Dialog
      classes={{
        root: classes.center,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={toggle}
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
    >
      <DialogTitle
        id="classic-modal-slide-title"
        disableTypography
        className={classes.modalHeader}
      >
        <IconButton
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={toggle}
        >
          <Close className={classes.modalClose} />
        </IconButton>
        <h4 className={classes.modalTitle}>Permohonan Surat</h4>
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        {data.step === "rejected" ? (
          <>
            <GridContainer justify="center">
              <GridItem xs={6} sm={6} md={6}>
                <img src={sadEmoji} alt="" style={{ width: "100%" }} />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem>
                <p>
                  Mohon maaf, ajuan surat permohonan Anda telah ditolak. Dengan
                  alasan:
                </p>
                <p>
                  <strong>{data.rejected_reason}</strong>
                </p>
                <p>Silahkan mengajukan ulang surat permohonan</p>
              </GridItem>
            </GridContainer>
          </>
        ) : (
          <>
            <Col>
              <Row>
                {data.addressed.identity ? <Check /> : <Clear />}{" "}
                <strong style={{ marginLeft: 7 }}>
                  Verifikasi oleh Operator
                </strong>
              </Row>
              <p style={{ marginLeft: 30 }}>
                {data.addressed.identity
                  ? "Permohonan surat Anda telah diverifikasi oleh Operator."
                  : "Permohonan surat Anda belum diverifikasi oleh Operator. Dimohon untuk bersabar."}
              </p>
            </Col>
            {data.signature_type === "manual" ? (
              <Col>
                <Row>
                  {data.requested_file ? <Check /> : <Clear />}{" "}
                  <strong style={{ marginLeft: 7 }}>
                    Upload Surat Permohonan
                  </strong>
                </Row>
                <p style={{ marginLeft: 30 }}>
                  {!data.addressed.identity
                    ? "Anda bisa mengupload surat permohonan setelah ajuan Anda diverifikasi."
                    : data.requested_file
                    ? "Surat permohonan telah diupload"
                    : "Silahkan download surat permohonan melalui link yang tersedia. Isi surat permohonan tersebut kemudian upload kembali."}
                </p>
                {data.addressed.identity ? (
                  <>
                    <div style={{ marginLeft: 30 }}>
                      <a
                        href={
                          baseUrl +
                          "/requested-letters/export-to-pdf/request/" +
                          data._id
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button color="twitter" simple>
                          Download surat permohonan
                        </Button>
                      </a>
                    </div>
                    {data.requested_file ? (
                      <p style={{ marginLeft: 30 }}>
                        Surat Permohonan telah diupload.
                      </p>
                    ) : (
                      <>
                        <GridContainer justify="center">
                          <GridItem md={11}>
                            <label>Upload Surat Pemohonan</label>
                            <input
                              className="MuiButtonBase-root MuiButton-root MuiButton-contained"
                              style={{ width: "100%" }}
                              type="file"
                              onChange={onChangeFile}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer justify="center">
                          <GridItem md={11}>
                            <Button onClick={upload} color="success">
                              Upload
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </>
                    )}
                  </>
                ) : null}
              </Col>
            ) : null}

            {data.signature_type === "digital" ? (
              <Col style={{ marginBottom: 15 }}>
                <Row>
                  {data.signature ? <Check /> : <Clear />}{" "}
                  <strong style={{ marginLeft: 7 }}>Tanda Tangan</strong>
                </Row>
                <p style={{ marginLeft: 30 }}>
                  {!data.addressed.identity
                    ? "Anda bisa menanda tangani surat permohonan setelah ajuan Anda diverifikasi."
                    : data.signature
                    ? "Surat permohonan telah ditanda tangani"
                    : "Silahkan tanda tangani surat permohonan Anda."}
                </p>
                {!data.signature && data.addressed.identity ? (
                  <>
                    <Col>
                      <SignaturePad
                        canvasProps={{ className: "signature-pad" }}
                        ref={(ref) => {
                          sigPad = ref;
                        }}
                        dotSize={1}
                      />
                    </Col>
                    <Button onClick={clearPad}>Bersihkan</Button>
                    <Button onClick={() => onSave(trimSign())}>Kirim</Button>
                  </>
                ) : data.signature ? (
                  <img
                    src={data.signature}
                    alt="signature"
                    className="signature-pad"
                  />
                ) : (
                  ""
                )}
              </Col>
            ) : null}

            <Col>
              <Row>
                {data.step === "finished" ? <Check /> : <Clear />}{" "}
                <strong style={{ marginLeft: 7 }}>Terima Surat Balasan</strong>
              </Row>
              {data.step === "finished" ? (
                <>
                  {data.is_fill_out_survey ? (
                    <>
                      <p style={{ marginLeft: 30 }}>
                        Silahkan download surat balasan{" "}
                      </p>
                      <div style={{ marginLeft: 30 }}>
                        <a
                          href={data.response_file || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button color="twitter" simple>
                            Download Surat Balasan
                          </Button>
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <p style={{ marginLeft: 30 }}>
                        Isi survei kepuasan untuk bisa mengunduh surat balasan.
                      </p>
                      <div style={{ marginLeft: 30 }}>
                        <Button
                          color="twitter"
                          simple
                          onClick={() => onFillSurvey()}
                        >
                          Isi Survei Kepuasan
                        </Button>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <p style={{ marginLeft: 30 }}>Surat balasan belum tersedia</p>
              )}
              {data.rated && data.thesis ? (
                <>
                  <p style={{ marginLeft: 30 }}>
                    Silahkan download berita acara{" "}
                  </p>
                  <div style={{ marginLeft: 30 }}>
                    <a
                      href={
                        baseUrl +
                        "/requested-letters/export-berita-acara/" +
                        data._id
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button color="twitter" simple>
                        Download Berita Acara
                      </Button>
                    </a>
                  </div>
                </>
              ) : null}
            </Col>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
